import axios from 'axios';
import { archive as seedArchive } from './data/archiveData';

const BASE = `${process.env.REACT_APP_BACKEND_URL}/api`;

function authHeader() {
  const token = localStorage.getItem('bn_token');
  return token ? { Authorization: `Bearer ${token}` } : {};
}

export async function login(username, password) {
  const { data } = await axios.post(`${BASE}/admin/login`, { username, password });
  localStorage.setItem('bn_token', data.token);
  return data;
}

export function logout() {
  localStorage.removeItem('bn_token');
}

export function isLoggedIn() {
  return !!localStorage.getItem('bn_token');
}

export async function verifyToken() {
  try {
    await axios.get(`${BASE}/admin/verify`, { headers: authHeader() });
    return true;
  } catch (e) {
    return false;
  }
}

// Fetch archive; auto-seed the DB from bundled data if empty
export async function fetchArchive() {
  const { data } = await axios.get(`${BASE}/archive`);
  if (Array.isArray(data) && data.length === 0) {
    try {
      await axios.post(`${BASE}/archive/seed`, { matches: seedArchive });
      const res = await axios.get(`${BASE}/archive`);
      return res.data;
    } catch (e) {
      return seedArchive;
    }
  }
  return data;
}

export async function fetchSettings() {
  const { data } = await axios.get(`${BASE}/settings`);
  return data;
}

export async function saveSettings(settings) {
  const { data } = await axios.put(`${BASE}/settings`, settings, { headers: authHeader() });
  return data;
}

export async function addMatch(match) {
  const { data } = await axios.post(`${BASE}/archive`, match, { headers: authHeader() });
  return data;
}

export async function updateMatch(id, match) {
  const { data } = await axios.put(`${BASE}/archive/${id}`, match, { headers: authHeader() });
  return data;
}

export async function deleteMatch(id) {
  const { data } = await axios.delete(`${BASE}/archive/${id}`, { headers: authHeader() });
  return data;
}

export async function importArchiveFromCode() {
  const { data } = await axios.post(`${BASE}/archive/import`, { matches: seedArchive }, { headers: authHeader() });
  return data;
}

// ---- Daily tips (Football Predictions Today) ----
export async function fetchDailyTips() {
  const { data } = await axios.get(`${BASE}/daily-tips`);
  return data;
}

export async function addDailyTip(tip) {
  const { data } = await axios.post(`${BASE}/daily-tips`, tip, { headers: authHeader() });
  return data;
}

export async function updateDailyTip(id, tip) {
  const { data } = await axios.put(`${BASE}/daily-tips/${id}`, tip, { headers: authHeader() });
  return data;
}

export async function deleteDailyTip(id) {
  const { data } = await axios.delete(`${BASE}/daily-tips/${id}`, { headers: authHeader() });
  return data;
}

// ---- Blog posts ----
export async function fetchPosts() {
  const { data } = await axios.get(`${BASE}/posts`);
  return data;
}

export async function fetchPost(slug) {
  const { data } = await axios.get(`${BASE}/posts/${slug}`);
  return data;
}

export async function fetchAdminPosts() {
  const { data } = await axios.get(`${BASE}/admin/posts`, { headers: authHeader() });
  return data;
}

export async function addPost(post) {
  const { data } = await axios.post(`${BASE}/posts`, post, { headers: authHeader() });
  return data;
}

export async function updatePost(id, post) {
  const { data } = await axios.put(`${BASE}/posts/${id}`, post, { headers: authHeader() });
  return data;
}

export async function deletePost(id) {
  const { data } = await axios.delete(`${BASE}/posts/${id}`, { headers: authHeader() });
  return data;
}

export async function seedGuides() {
  const { data } = await axios.post(`${BASE}/posts/seed-guides`, {}, { headers: authHeader() });
  return data;
}
